/* Each page's top N contains every possible winner of the full collection. */
(() => {
  function selectWeeklyCards(cards, limit) {
    const unique = new Map(cards.map((card) => [card.dataset.productId, card]));
    return [...unique.values()]
      .sort((a, b) => {
        const left = a.dataset.weeklyRank + ':' + a.dataset.productId;
        const right = b.dataset.weeklyRank + ':' + b.dataset.productId;
        return left < right ? -1 : left > right ? 1 : 0;
      })
      .slice(0, limit);
  }

  if (typeof module !== 'undefined') module.exports = { selectWeeklyCards };
  if (typeof customElements === 'undefined' || customElements.get('dhuni-weekly-products')) return;

  customElements.define('dhuni-weekly-products', class extends HTMLElement {
    connectedCallback() {
      if (Number(this.dataset.pages) <= 1 || this.loading) return;
      this.loading = true;
      this.controller = new AbortController();
      this.loadRemainingPages().catch((error) => {
        // Keep the server-rendered, in-stock selection when a request fails.
        if (error.name !== 'AbortError') console.warn('Weekly product selection:', error);
      }).finally(() => { this.loading = false; });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async loadRemainingPages() {
      const cards = [...this.querySelectorAll('[data-weekly-rank]')];
      for (let page = 1; page <= Number(this.dataset.pages); page++) {
        if (page === Number(this.dataset.page)) continue;
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set(this.dataset.pageParam, page);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(`Section request failed: ${response.status}`);
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const pool = document.querySelector('dhuni-weekly-products');
        if (!pool || pool.dataset.collectionId !== this.dataset.collectionId || pool.dataset.week !== this.dataset.week || Number(pool.dataset.page) !== page) {
          throw new Error('Weekly product page did not match the requested week/page');
        }
        cards.push(...pool.querySelectorAll('[data-weekly-rank]'));
      }
      if (!this.isConnected) return;
      const selected = selectWeeklyCards(cards, Number(this.dataset.limit));
      if (selected.length) this.replaceChildren(...selected);
    }
  });
})();
